export const credentialAuthFlowCopyFieldDefinitions = [
  { id: 'continueWithEmail', group: 'Actions', label: 'Continue with Email' },
  { id: 'emailLoginTitle', group: 'Titles', label: 'Email login title' },
  { id: 'signupTitle', group: 'Titles', label: 'Registration title' },
  {
    id: 'signupVerificationTitle',
    group: 'Titles',
    label: 'Registration verification title',
  },
  {
    id: 'registrationCompleteTitle',
    group: 'Titles',
    label: 'Registration complete title',
  },
  {
    id: 'resetPasswordTitle',
    group: 'Titles',
    label: 'Password reset title',
  },
  {
    id: 'resetVerificationTitle',
    group: 'Titles',
    label: 'Password reset verification title',
  },
  {
    id: 'resetCompleteTitle',
    group: 'Titles',
    label: 'Password reset complete title',
  },
  { id: 'emailLabel', group: 'Fields', label: 'Email field label' },
  { id: 'passwordLabel', group: 'Fields', label: 'Password field label' },
  { id: 'emailPlaceholder', group: 'Fields', label: 'Email placeholder' },
  {
    id: 'passwordPlaceholder',
    group: 'Fields',
    label: 'Password placeholder',
  },
  {
    id: 'newPasswordLabel',
    group: 'Fields',
    label: 'New password field label',
  },
  {
    id: 'confirmPasswordLabel',
    group: 'Fields',
    label: 'Confirm password field label',
  },
  {
    id: 'verificationCodeLabel',
    group: 'Fields',
    label: 'Verification code field label',
  },
  { id: 'signInAction', group: 'Actions', label: 'Sign-in action' },
  {
    id: 'forgotPasswordAction',
    group: 'Actions',
    label: 'Forgot password action',
  },
  { id: 'signupAction', group: 'Actions', label: 'Registration action' },
  {
    id: 'createAccountAction',
    group: 'Actions',
    label: 'Create account action',
  },
  {
    id: 'existingAccountPrompt',
    group: 'Actions',
    label: 'Existing account prompt',
  },
  {
    id: 'sendResetCodeAction',
    group: 'Actions',
    label: 'Send reset code action',
  },
  {
    id: 'resendCodeAction',
    group: 'Actions',
    label: 'Resend code action',
  },
  {
    id: 'backToMethodsAction',
    group: 'Actions',
    label: 'Back to sign-in methods action',
  },
  {
    id: 'backToEmailLoginAction',
    group: 'Actions',
    label: 'Back to email login action',
  },
  {
    id: 'backToLoginAction',
    group: 'Actions',
    label: 'Back to login action',
  },
  {
    id: 'changeEmailAction',
    group: 'Actions',
    label: 'Change email action',
  },
  {
    id: 'passwordRules',
    group: 'Messages',
    label: 'Password rules message',
  },
  {
    id: 'registrationCodeSent',
    group: 'Messages',
    label: 'Registration code sent message',
  },
  {
    id: 'resetCodeSent',
    group: 'Messages',
    label: 'Password reset code sent message',
  },
  {
    id: 'passwordMismatch',
    group: 'Messages',
    label: 'Password mismatch message',
  },
  {
    id: 'genericFailure',
    group: 'Errors',
    label: 'Generic credential failure',
  },
  {
    id: 'invalidVerificationCode',
    group: 'Errors',
    label: 'Invalid or expired verification code error',
  },
  { id: 'invalidInput', group: 'Errors', label: 'Invalid input error' },
  {
    id: 'unsupportedEmailProvider',
    group: 'Errors',
    label: 'Unsupported email provider error',
  },
  { id: 'rateLimited', group: 'Errors', label: 'Rate limit error' },
  { id: 'unavailable', group: 'Errors', label: 'Unavailable error' },
  {
    id: 'temporarilyUnavailable',
    group: 'Errors',
    label: 'Temporary unavailable error',
  },
  {
    id: 'captchaFailed',
    group: 'Errors',
    label: 'Turnstile verification error',
  },
] as const;

export type CredentialAuthFlowCopyFieldId =
  (typeof credentialAuthFlowCopyFieldDefinitions)[number]['id'];

export type CredentialAuthFlowCopy<Value = string> = {
  [FieldId in CredentialAuthFlowCopyFieldId]: Value;
};

export function createCredentialAuthFlowCopy<Value>(
  createValue: (fieldId: CredentialAuthFlowCopyFieldId) => Value
): CredentialAuthFlowCopy<Value> {
  return Object.fromEntries(
    credentialAuthFlowCopyFieldDefinitions.map(({ id }) => [
      id,
      createValue(id),
    ])
  ) as CredentialAuthFlowCopy<Value>;
}

export function mapCredentialAuthFlowCopy<SourceValue, TargetValue>(
  copy: CredentialAuthFlowCopy<SourceValue>,
  mapValue: (
    value: SourceValue,
    fieldId: CredentialAuthFlowCopyFieldId
  ) => TargetValue
): CredentialAuthFlowCopy<TargetValue> {
  return createCredentialAuthFlowCopy((fieldId) =>
    mapValue(copy[fieldId], fieldId)
  );
}
